var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDownloadingArrow = function SvgIconDownloadingArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M40.653 79c-1.728 0-2.916-1.315-3.046-1.467L13.778 49.282c-.63-.575-2.256-2.306-1.641-3.82.363-.899 1.317-1.358 2.829-1.358H27.25V4.217c-.061-.376-.11-1.237.5-2.012C28.378 1.407 29.453 1 30.942 1h18.881c1.336 0 2.109.497 2.52.913.774.781.786 1.728.781 1.907v39.446h11.258c.695 0 2.812 0 3.458 1.536.675 1.605-.962 3.375-1.478 3.879-.723.958-20.241 26.361-23.08 29.151-.983.964-1.972 1.168-2.629 1.168"
  })));
};
export default SvgIconDownloadingArrow;